<div class="row" style="margin-bottom:15px !important">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px;">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">{{title}}</span>
        </h6>
    </div>
    <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="container">
            <div class="row t30-padding">
                <div class="col-md-12 col-sm-12 no-padding" style="padding-bottom:30px">
                    <mat-form-field appearance="legacy" style="width:80%">
                        <mat-label>Email address</mat-label>
                        <input [(ngModel)]="newFollowerEmail" matInput placeholder="">
                        <span matSuffix>
                            {{ emailSuffix }}
                        </span>
                    </mat-form-field>
                    <a *ngIf="!ccAddLoading" style="color:green;cursor:pointer; padding-left:5px" (click)="addFollowers(newFollowerEmail)">
                        <span class="fa fa-plus"></span>
                    </a>
                    <a *ngIf="ccAddLoading" style="color:red;cursor:pointer; padding-left:5px">
                        <span class="fa fa-spinner"></span>
                    </a>
                </div>

                <div class="col-md-12 col-sm-12 no-padding">
                    <div class="col-md-12 col-sm-12 no-padding" *ngFor="let item of Followers; let i = index">

                        <div class="row userlist" style="padding-bottom:15px">
                            <div class="col-xl-2" style="padding:0px">
                                <div class="postContactLogo default-bg" style="border-radius: 50%; background-size: cover; width: 40px; height: 40px" [ngStyle]="{'background-image': 'url(' + item.contactLogo + ')'}">
                                </div>
                            </div>
                            <div class="col-xl-8">
                                {{item.name}}<br />
                                <small class="feed-time-date">
                                    <span>{{item.email}}</span>
                                </small>
                            </div>
                            <div class="col-xl-2">
                                <a *ngIf="!ccDeleteLoading" style="color:red;cursor:pointer; padding-left:5px" (click)="deleteFollower(item.id)">
                                    <span class="fa fa-trash"></span>
                                </a>
                                <a *ngIf="ccDeleteLoading" style="color:red;cursor:pointer; padding-left:5px">
                                    <span class="fa fa-spinner"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="Followers.length == 0">
                        No followers found
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
